import { render, staticRenderFns } from "./UserFamilyItemParent.vue?vue&type=template&id=137ccaff&scoped=true&"
import script from "./UserFamilyItemParent.vue?vue&type=script&lang=js&"
export * from "./UserFamilyItemParent.vue?vue&type=script&lang=js&"
import style0 from "./UserFamilyItemParent.vue?vue&type=style&index=0&id=137ccaff&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "137ccaff",
  null
  
)

export default component.exports